import React from "react";
import { themeStyle, themeStyleDark } from "./Components";
import { useSelector } from "react-redux";
import { Grid } from "@mui/material";
import Button from "@mui/material/Button";
import XIcon from "@mui/icons-material/X";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import YouTubeIcon from "@mui/icons-material/YouTube";
import EmailIcon from "@mui/icons-material/Email";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import { useNavigate } from "react-router-dom";

export default function Footer(props) {
  const state = useSelector((state) => state);
  const navigate = useNavigate();
  return (
    <div>
      <div
        className="footer"
        style={{
          backgroundColor: "black",
          padding: state.auth.isMobile ? "20px" : "50px",
          paddingBottom: state.auth.isMobile ? "20px" : "0px",

          backgroundColor:
            state.auth.theme == "dark"
              ? themeStyleDark.primaryColor
              : themeStyle.primaryColor,
        }}
      >
        <Grid container spacing={5}>
          <Grid
            item
            md={5}
            style={{
              height: "100%",
              width: "100%",
            }}
          >
            <div
              style={{
                fontSize: state.auth.isMobile ? "30px" : "30px",
                fontFamily: "Montserrat",
                color: "white",
                fontWeight: "bold",
                textAlign: "left",
              }}
            >
              BGS WORLD SCHOOL
            </div>
            <br />
            <div
              style={{
                fontSize: "20px",
                fontFamily: "Montserrat",
                color: "white",
                marginBottom: "50px",
                textAlign: "left",
              }}
            >
              P723+VMF, Mysore Rd, Archikarahalli, Bengaluru, Doddamannugudde
              Forest, Karnataka 562159
            </div>
          </Grid>

          <Grid
            item
            md={2}
            style={{
              height: "100%",
              width: "100%",
              marginTop: state.auth.isMobile ? "-50px" : 0,
            }}
          >
            {" "}
            <div
              onClick={() => {
                navigate("/about_school");
              }}
              style={{
                fontSize: state.auth.isMobile ? "16px" : "20px",
                fontFamily: "Montserrat",
                color: "white",
                cursor: "pointer",
                fontWeight: 600,
              }}
            >
              About School
            </div>
            <div
              onClick={() => {
                navigate("/about_math");
              }}
              style={{
                fontSize: state.auth.isMobile ? "16px" : "20px",
                fontFamily: "Montserrat",
                color: "white",
                cursor: "pointer",
                fontWeight: 600,
              }}
            >
              About Math
            </div>
            <div
              onClick={() => {
                navigate("/about_principal");
              }}
              style={{
                fontSize: state.auth.isMobile ? "16px" : "20px",
                fontFamily: "Montserrat",
                color: "white",
                cursor: "pointer",
                fontWeight: 600,
              }}
            >
              About Principal
            </div>
            <div
              onClick={() => {
                navigate("/overview");
              }}
              style={{
                fontSize: state.auth.isMobile ? "16px" : "20px",
                fontFamily: "Montserrat",
                color: "white",
                cursor: "pointer",
                fontWeight: 600,
              }}
            >
              Admissions
            </div>
          </Grid>
          <Grid
            item
            md={2}
            style={{
              height: "100%",
              width: "100%",
            }}
          >
            {" "}
            <div
              onClick={() => {
                navigate("/about_school");
              }}
              style={{
                fontSize: state.auth.isMobile ? "16px" : "20px",
                fontFamily: "Montserrat",
                color: "white",
                cursor: "pointer",
                fontWeight: 600,
              }}
            >
              BGS World School
            </div>
            <div
              onClick={() => {
                navigate("/registration");
              }}
              style={{
                fontSize: state.auth.isMobile ? "16px" : "20px",
                fontFamily: "Montserrat",
                color: "white",
                cursor: "pointer",
                fontWeight: 600,
              }}
            >
              Apply Now
            </div>
            <div
              onClick={() => {
                navigate("/contact");
              }}
              style={{
                fontSize: state.auth.isMobile ? "16px" : "20px",
                fontFamily: "Montserrat",
                color: "white",
                cursor: "pointer",
                fontWeight: 600,
              }}
            >
              Contact Us
            </div>
            <div
              onClick={() => {
                navigate("/facilities");
              }}
              style={{
                fontSize: state.auth.isMobile ? "16px" : "20px",
                fontFamily: "Montserrat",
                color: "white",
                cursor: "pointer",
                fontWeight: 600,
              }}
            >
              Facilities
            </div>
          </Grid>
          <Grid
            item
            md={3}
            style={{
              height: "100%",
              width: "100%",
            }}
          >
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Button
                onClick={() => {
                  window.location.href =
                    "https://youtube.com/@bgsworldschool?si=XnpGpMDNHDIRpJcy";
                }}
                style={{
                  border: "2px white solid",
                  borderRadius: "40px",
                  width: "70px",
                  height: "70px",
                  fontSize: "20px",
                  color: "white",
                }}
              >
                <YouTubeIcon style={{ color: "white", fontSize: "40px" }} />
              </Button>
              <Button
                onClick={() => {
                  window.location.href = "mailto:bgs.rmg@gmail.com";
                }}
                style={{
                  border: "2px white solid",
                  borderRadius: "40px",
                  width: "70px",
                  height: "70px",
                  fontSize: "20px",
                  color: "white",
                }}
              >
                <EmailIcon style={{ color: "white", fontSize: "40px" }} />
              </Button>
              <Button
                onClick={() => {
                  window.location.href =
                    "https://www.facebook.com/share/18CgAKnSXB/";
                }}
                style={{
                  border: "2px white solid",
                  borderRadius: "40px",
                  width: "70px",
                  height: "70px",
                  fontSize: "20px",
                  color: "white",
                }}
              >
                <FacebookIcon style={{ color: "white", fontSize: "40px" }} />
              </Button>
              <Button
                onClick={() => {
                  window.location.href =
                    "https://www.instagram.com/bgsworldschoolramnagara?igsh=ODRwNTlwaGdrNnhp";
                }}
                style={{
                  border: "2px white solid",
                  borderRadius: "40px",
                  width: "70px",
                  height: "70px",
                  fontSize: "20px",
                  color: "white",
                }}
              >
                <InstagramIcon style={{ color: "white", fontSize: "40px" }} />
              </Button>
            </div>
          </Grid>
        </Grid>
      </div>
      <div>
        <Grid
          container
          style={{
            minHeight: "80px",
            width: "100%",
            backgroundColor: "white",
            padding: state.auth.isMobile ? "25px" : "0px 10% 0px 10%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Grid
            item
            md={6}
            xs={12}
            style={{
              height: "100%",
              width: "100%",
              color: "grey",
            }}
          >
            <div
              style={{
                fontSize: state.auth.isMobile ? "16px" : "18px !important",
                textAlign: "left",
              }}
            >
              Copyright © 2025 BGS World School. All rights reserved.
            </div>
          </Grid>
          <Grid
            item
            md={6}
            xs={12}
            style={{
              height: "100%",
              width: "100%",
              color: "grey",
              marginTop: state.auth.isMobile ? "25px" : 0,
            }}
          >
            <div
              style={{
                fontSize: state.auth.isMobile ? "16px" : "18px !important",
                textAlign: "left",
              }}
            >
              Developed and Designed by{" "}
              <a href="https://softwarepro.in">
                Softwarepro Technologies Private Limited
              </a>
            </div>
          </Grid>
        </Grid>
      </div>
    </div>
  );
}
